import { Tooltip } from '@fluentui/react-components';
import * as fluentIcons from '@fluentui/react-icons';
import { useContext } from 'react';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { formatSkillDate } from 'src/utils/dateFns/formatDate';

interface SkillsStatusIndicatorProps {
  status: string;
  requestedAttitude?: string;
  requestedLevel?: string;
  validatedBy?: string;
  validatedDate?: string;
}

export const SkillsStatusIndicator = ({
  status,
  requestedAttitude,
  requestedLevel,
  validatedBy,
  validatedDate,
}: SkillsStatusIndicatorProps) => {
  const { themeString } = useContext(TeamsFxContext);

  const iconType = themeString === 'dark' ? 'Filled' : 'Regular';

  const statusIcons = {
    approved: fluentIcons[`CheckmarkCircle20${iconType}`],
    pending: fluentIcons[`MoreCircle20${iconType}`],
  };

  const approvedContent = validatedDate && (
    <div
      style={{ whiteSpace: 'pre-line' }}
    >{`Validated by ${validatedBy}\nDate: ${formatSkillDate(
      validatedDate
    )}`}</div>
  );
  const pendingContent = (
    <div
      style={{ whiteSpace: 'pre-line' }}
    >{`Pending validation\nLevel: ${requestedLevel}\nAttitude: ${requestedAttitude}`}</div>
  );
  switch (status) {
    case '1':
      return (
        <>
          {validatedDate || validatedBy ? (
            <Tooltip content={approvedContent} relationship="description">
              <statusIcons.approved color="#237B4B"></statusIcons.approved>
            </Tooltip>
          ) : (
            <statusIcons.approved color="#237B4B"></statusIcons.approved>
          )}
        </>
      );
    case '2':
      return (
        <>
          {requestedAttitude || requestedAttitude ? (
            <Tooltip content={pendingContent} relationship="description">
              <statusIcons.pending color="#0078D4"></statusIcons.pending>
            </Tooltip>
          ) : (
            <statusIcons.pending color="#0078D4"></statusIcons.pending>
          )}
        </>
      );
    default:
      return (
        <>
          {requestedAttitude || requestedAttitude ? (
            <Tooltip content={pendingContent} relationship="description">
              <statusIcons.pending color="#0078D4"></statusIcons.pending>
            </Tooltip>
          ) : (
            <statusIcons.pending color="#0078D4"></statusIcons.pending>
          )}
        </>
      );
  }
};
